module.exports = __webpack_public_path__ + "static/media/An_Nguyen_Treatment_Coor.156a122d.png";